import Language from "./enums/Language"

let translationWords = [
	{
		language: Language.PORTUGUESE,
		daysPart: (days) => `Até ${days} ${days>1?'dias':'dia'} antes do checkin - sem taxas.`,
		taxPolicyDays: (daysPenalityTax) => ` Depois disso, ${daysPenalityTax} ${daysPenalityTax>1?'noites serão cobradas.': 'noite será cobrada.'}`,
		taxPolicyPercent: (percentTax) => ` Depois disso, será cobrado ${percentTax}% do valor da reserva.`,
		refundable: 'Não reembolsável.',
	},
	{
		language: Language.ENGLISH,
		daysPart: (days) => `Until ${days} ${days>1?'days':'day'} before checkin - no penalty.`,
		taxPolicyDays: (daysPenalityTax) => ` After that, ${daysPenalityTax} ${daysPenalityTax>1?'nights will be charged.': 'night will be charged.'}`,
		taxPolicyPercent: (percentTax) => ` After that, ${percentTax}% of the reservation amount will be charged.`,
		refundable: 'Non refundable.',
	},
	{
		language: Language.SPANISH,
		daysPart: (days) => `Hasta ${days} ${days>1?'días':'día'} antes del checkin -`,
		taxPolicyDays: (daysPenalityTax) => ` Después de eso, se cobrará ${daysPenalityTax} ${daysPenalityTax>1?'se cobrarán las noches': 'se cobrará la noche'}`,
		taxPolicyPercent: (percentTax) => ` Después de eso, se cobrará ${percentTax}% del monto de la reserva`,
		refundable: 'No reembolsable',
	},
];

export function describeCancelationPolicy(cancellationPolicy, language) {
	let currentLanguage = translationWords.find(tr => tr.language.id === language.id);
	if(cancellationPolicy.nonRefundable) {
		return currentLanguage.refundable;
	}

	let cancelationPolicyDescription = "";
	let daysBeforeCheckin = cancellationPolicy.daysBeforeCheckin;
	let daysPenality = cancellationPolicy.dailyPenalty;
	let percentTax = cancellationPolicy.percentagePenalty;
	if(daysBeforeCheckin) {
		cancelationPolicyDescription = `${currentLanguage.daysPart(daysBeforeCheckin)} ${cancelationPolicyDescription}`;
		if(daysPenality) {
		cancelationPolicyDescription += currentLanguage.taxPolicyDays(daysPenality);
		} else if(percentTax) {
			cancelationPolicyDescription += currentLanguage.taxPolicyPercent(percentTax);
		}
	};
	return cancelationPolicyDescription;
}



// WEBPACK FOOTER //
// ./src/cancellation-policy-utils.js